// Base
import { DetailedHTMLProps, InputHTMLAttributes } from 'react'

// Components
import { Box, Flex } from 'yard-utilities/components'

// Styles
import styles from './Input.module.sass'

interface InputProps
  extends DetailedHTMLProps<
    InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  startIcon?: React.ReactNode
  endIcon?: React.ReactNode
  label?: string
}

const Input = ({ startIcon, endIcon, label, ...rest }: InputProps) => {
  const { style, name, className, disabled, ...restProps } = rest

  return (
    <div className={styles.inputWrapper}>
      {label && (
        <label htmlFor={name} className={styles.label}>
          {label}
        </label>
      )}
      <Box
        backgroundColor="white"
        borderRadius={{ sm: [8] }}
        border="black-10"
        padding={{ sm: [0, 16] }}
        className={`${styles.inputGroup} ${className} ${
          disabled ? styles.disabled : ''
        }`}
        style={style}
      >
        <Flex
          alignItems="center"
          columnGap={{ sm: 16 }}
          className={styles.inputGroupInner}
        >
          {startIcon && <div className={styles.startIcon}>{startIcon}</div>}
          <input name={name} disabled={disabled} {...restProps} />
          {endIcon && <div className={styles.endIcon}>{endIcon}</div>}
        </Flex>
      </Box>
    </div>
  )
}

export { Input }
